import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaUserCheck, FaUsers, FaStar, FaCertificate } from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaUserCheck />,
      title: 'Personalized Care',
      description: 'Our care plans to meet the specific needs and preferences of each client, ensuring tailored support.'
    },
    {
      icon: <FaUsers />,
      title: 'Experienced Team',
      description: 'Our healthcare professionals are highly skilled and dedicated to providing exceptional care.'
    },
    {
      icon: <FaStar />,
      title: 'Quality',
      description: 'We are committed to continuous improvement and innovation in healthcare services.'
    },
    {
      icon: <FaCertificate />,
      title: 'Certified',
      description: 'All our caregivers are fully certified and undergo continuous training to maintain high standards.'
    }
  ];

  return (
    <section className="why-choose-section">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Why Choose Us</h2>
          <p className="section-subtitle">Where Quality, Compassion, And Expertise Meet</p>
        </div>
        
        <Row className="g-4">
          {reasons.map((reason, index) => (
            <Col key={index} lg={3} md={6}>
              <div className="why-card text-center">
                <div className="why-icon">
                  {reason.icon}
                </div>
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default WhyChooseUs;
